module.exports = __webpack_public_path__ + "static/media/topgolfentertainmentgroup.5fe4615a.png";